var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('el-button',{staticStyle:{"margin-bottom":"6px"},attrs:{"type":"primary","size":"mini","icon":_vm.btnInfo.icon},on:{"click":_vm.getcc}},[_vm._v(_vm._s(_vm.btnInfo.label))])],1),_c(_vm.getComp,{tag:"component",attrs:{"tableInfo":_vm.tableInfo},on:{"create":_vm.setTableInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }